/*
 * Loads the SIP.js 0.21.2 browser bundle (public/vendor) on demand, the first
 * time a telecaller clicks Connect Phone, so pages that never use the phone
 * don't pay for it. The bundle defines a global `SIP`.
 */

const SIP_BUNDLE_URL = `${process.env.PUBLIC_URL}/vendor/sip-0.21.2.bundle.js`;

let loading = null;

export const loadSip = () => {
  if (window.SIP?.UserAgent) return Promise.resolve(window.SIP);
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = SIP_BUNDLE_URL;
      script.async = true;
      script.onload = () => {
        if (window.SIP?.UserAgent) {
          resolve(window.SIP);
        } else {
          loading = null;
          reject(new Error("The phone library did not load correctly."));
        }
      };
      script.onerror = () => {
        loading = null;
        script.remove();
        reject(new Error("Could not load the phone library."));
      };
      document.head.appendChild(script);
    });
  }
  return loading;
};
